import {
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  HostListener,
  AfterViewInit,
  inject
} from '@angular/core';

@Component({
  selector: 'app-popover',
  standalone: false,
  templateUrl: './popover.component.html',
  styleUrl: './popover.component.less',
})
export class PopoverComponent implements AfterViewInit {
  // Recibe el elemento HTML que actúa como disparador
  @Input({ required: true }) trigger!: HTMLElement;

  // Emite un evento cuando se detecta un clic fuera
  @Output() closed = new EventEmitter<void>();
  
  // Inyecta una referencia al propio elemento <app-popover>
  private elementRef = inject(ElementRef);

  // Escucha todos los clics en el documento
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    const clickedOnTrigger = this.trigger.contains(event.target as Node);

    // Si el clic NO fue dentro del popover NI en el disparador, se cierra.
    if (!clickedInside && !clickedOnTrigger) {
      this.closed.emit();
    }
  }

  ngAfterViewInit(): void {
    // Una vez que la vista se ha inicializado, posiciona el popover
    this.positionPopover();
  }

  private positionPopover(): void {
    if (!this.trigger) return;

    const hostElement = this.elementRef.nativeElement as HTMLElement;
    const triggerRect = this.trigger.getBoundingClientRect();

    // Calcula la posición debajo del disparador
    // window.scrollY compensa el desplazamiento vertical de la página
    const top = triggerRect.bottom + window.scrollY + 8; // 8px de margen
    const left = triggerRect.left + window.scrollX;

    // Aplica los estilos directamente al host del componente
    hostElement.style.top = `${top}px`;
    hostElement.style.left = `${left}px`;
  }
}